// Soft-warning helper for backfilled SOW / Variation forms. Returns a
// string the caller can render in amber tertiary text below a date
// input when the supplied ISO date is more than 365 days in the past.
// Returns null otherwise — callers conditionally render only when the
// helper has something to say.
//
// The form still accepts these dates (backfilling is a valid workflow
// per the brief). The warning is informational, designed to catch
// typos like a stray `2024` when the user meant `2026`.

const DAY_MS = 86_400_000;

export function pastDateWarning(
  iso: string,
  today: Date = new Date(),
): string | null {
  if (!iso) return null;
  const d = new Date(`${iso}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return null;
  const todayMs = Date.UTC(
    today.getUTCFullYear(),
    today.getUTCMonth(),
    today.getUTCDate(),
  );
  const dateMs = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  const diff = todayMs - dateMs;
  if (diff <= 365 * DAY_MS) return null;
  const years = Math.floor(diff / (365 * DAY_MS));
  if (years <= 1) {
    return "This date is more than a year in the past — check it is correct.";
  }
  return `This date is more than ${years} years in the past — check it is correct.`;
}
